// This file is AUTOGENERATED, do not edit it manually!!!

export const resourcePlanning = {
    ability_to_fit_label: 'ability to fit',
    add_allocation_title: 'Add allocation',
    add_approver_button: 'Add approver',
    add_to_project: 'Add to project',
    add_user_link: 'Add user',
    allocate_resources: 'Allocate resources',
    allocated_label: 'Allocated',
    AllocatedHoursColumn: 'Allocated hours',
    allocation_approved_alert: 'Allocation was approved by {0} on {1}',
    allocation_hard_label: 'Hard',
    allocation_has_been_created: 'Allocation has been created',
    allocation_has_been_updated: 'Allocation has been updated',
    allocation_percentage_label: 'Allocation percentage',
    allocation_period_conflict: 'This period already includes allocation',
    allocation_reject_alert: 'Allocation was rejected by {0} on {1}',
    allocation_request_approved_feedback: 'Resource request has been approved',
    allocation_request_rejected_feedback: 'Resource request has been rejected',
    allocation_request_waiting_feedback: 'Resource request has been created',
    allocation_required: 'Allocation required',
    allocation_soft_label: 'Soft',
    allocation_type_change_with_approval_rquest_warning: 'Changing the allocation type to hard will result in the removal of the resource request',
    allocation_type_description: 'Hard - confirmed allocation. Soft - tentative allocation.',
    allocation_type_label: 'Allocation type',
    allocation_waiting_alert: 'Allocation has been awaiting approval since {0}',
    approve_modal_header_text: 'Approve resource request for users?',
    approve_request: 'Approve request',
    approve_request_info: 'This batch operation only applies to resource requests created for users.',
    Approve_Success_Message: '1#{0} allocation has been approved#{0} allocations have been approved',
    approved_by: 'Approved by',
    approver: 'Approver',
    AvailabilityTooltip: '% of days for the planned allocation duration, where person may have hard allocations on other projects, which will not consume all person’s capacity based on the personal schedule and vacations and company holidays',
    available_label: 'Available',
    available_projects: 'Available projects',
    awaiting_approval_from: 'Awaiting approval from',
    be_aware_all_will_be_transferred: 'Be aware that all allocations, assignments, and scheduled hours will be transferred to the selected user.',
    calculate_based_message: 'Calculation of hours based on',
    capacity_label: 'Capacity',
    check_all: 'Check all',
    choice_description_generate_on_project_timeline: 'Allocations (bookings) will be created for each project member for the entire duration of their project',
    choice_description_generate_on_scheduled_hours: 'Allocations (bookings) will be created only for task assignees based on the scheduled hours of their assigned tasks',
    choice_title_generate_on_project_timeline: 'Generate allocations based on project timelines',
    choice_title_generate_on_scheduled_hours: 'Generate allocations based on scheduled hours',
    column_title_availability: 'Ability to fit, %',
    column_title_job_role: 'Job role match',
    column_title_resource: 'Resource',
    column_title_skills: 'Skills match',
    column_title_user: 'User',
    company_schedule_link: 'Company schedule',
    completed_projects_label: 'Completed projects',
    copy_multiple_times_message: 'Specify how many copies of the selected unnamed resource to create. Maximum amount: 20 copies.',
    copy_unnamed_title: 'Copy \"{0}\"?',
    copy_with_allocations_label: 'Copy with allocations',
    demand_label: 'Demand',
    Description_AllocatedMinutes: 'Amount of time a resource is reserved to dedicate to a project.',
    Description_HourlyRateInternal: 'Resource internal hourly rate.',
    Description_ScheduledMinutes: 'Number of hours a resource is scheduled to spend on each task for a project.',
    edit_allocation_title: 'Edit allocation',
    effortlessly_namage_resources_label: 'Effortlessly manage resources with Resource Planning',
    find_candidates: 'Find candidates',
    find_candidates_not_available_no_unnamed: 'Add unnamed resources to find the best match to replace them',
    free: 'Free',
    generate_allocations_action: 'Generate allocations',
    generate_allocations_button: 'Generate allocations',
    generate_allocations_description: 'Allocations will be generated based on the weekly scheduled hours for this resource.',
    generate_allocations_info: 'This batch operation generates allocations for both users and unnamed resources based on their scheduled project hours.',
    generate_allocations_to_have_scheduled_hours: 'To have scheduled hours - assign resource to the task with timelines and estimated hours.',
    generate_button: 'Generate',
    generate_button_warning_text: 'Generating allocations is safe and will not disrupt task assignments or alter workload at the task level',
    generate_hard_allocation_disabled_tooltip_description: 'You need to have the \"Manage hard allocations\" permission to use this option. Allocations cannot be generated for users with both hard and soft allocations.',
    generate_hard_allocation_tooltip_description: 'Hard allocations will be generated for users only. Unnamed resources will be skipped.',
    generate_label: 'Generate as:',
    generate_modal_description_text: 'All allocations for the selected users and unnamed resources will be generated based on the current estimated hours and timelines for the corresponding activities.',
    generate_modal_description_text_single_resource: 'All allocations for \"{0}\" will be generated based on the current estimated hours and timelines for the corresponding activities.',
    generate_modal_header_text: 'Generate allocations for selected users and unnamed resources?',
    generate_modal_header_text_single_resource: 'Generate allocations for \"{0}\"?',
    generate_success_message: '1#{0} allocation has been generated#{0} allocations have been generated',
    group_by_job_role_label: 'Group by job role',
    group_by_project_label: 'Group by project',
    group_by_resource_label: 'Group by resource',
    HardAllocation: 'Hard allocation',
    HardAllocationTooltip: 'Unnamed resources can be only soft allocated',
    help_tooltip_description: 'Hard and soft allocations let you assign resources to projects with different levels of flexibility.',
    HourlyRateInternalColumn: 'Internal rate',
    include_soft_allocations_to_workload: 'Include soft allocations to workload',
    job_role_capacity: 'Job role capacity',
    legend_title: 'Legend',
    message: 'Message',
    message_tooltip: 'Add the rejection or approval reason, or any additional message. It will be added as a separate message to the project details.',
    name_column_group_by_JobRole: 'Roles, resources and projects',
    name_column_group_by_Project: 'Projects and resources',
    name_column_group_by_User: 'Resources and projects',
    no_jobrole: 'There are no job role visible to you',
    no_jobrole_match_selected_filters: 'Sorry, no job role match selected filters',
    no_project: 'There are no project visible to you',
    no_project_match_selected_filters: 'Sorry, no project match selected filters',
    no_scheduled_hours_description: 'There are no scheduled hours on the task assignments for this resource.',
    no_user: 'There are no resource visible to you',
    no_user_match_selected_filters: 'Sorry, no resource match selected filters',
    NormalizeApprovers_Feedback: 'The resource request has been reset because the previous approver no longer has the necessary permissions.',
    other_hard_allocations: 'Other hard allocations',
    other_projects_label: 'Other projects',
    other_projects_tooltip: 'Refers to projects that either do not fall under the applied filters or that you do not have the necessary permissions to access.',
    over: 'Over',
    overloaded_label: 'Overloaded',
    overscheduled_hours_label: 'Overscheduled hours',
    planning_onboarding_description: 'A powerful tool for booking resources at the project level, providing a high-level view of resource usage across all projects to help you make informed strategic decisions',
    planning_onboarding_title: 'Welcome to the new Resource Planning feature!',
    project_timeline_label: 'Project timeline',
    recommended_users_label: 'AI recommended users',
    regenerate_allocations_button: 'Re-generate allocations',
    regenerate_allocations_info: 'This batch operation re-generates allocations for both users and unnamed resources based on their scheduled project hours.',
    regenerate_button: 'Re-generate',
    regenerate_hard_allocation_disabled_tooltip_description: 'You need to have the \"Manage hard allocations\" permission to use this option. Allocations cannot be re-generated for users with both hard and soft allocations.',
    regenerate_hard_allocation_tooltip_description: 'Hard allocations will be re-generated for users only. Unnamed resources will be skipped.',
    regenerate_label: 'Re-generate as:',
    regenerate_modal_description_text: 'All allocations for the selected users and unnamed resources will be re-generated based on the current estimated hours and timelines for the corresponding activities. If a user or unnamed resource has been unassigned from activities, their allocations will be deleted.',
    regenerate_modal_header_text: 'Re-generate allocations for selected users and unnamed resources?',
    regenerate_success_message: '1#{0} allocation has been re-generated#{0} allocations have been re-generated',
    regular_workload_label: 'Regular workload',
    reject_modal_header_text: 'Reject resource request for users and unnamed resources?',
    reject_request: 'Reject request',
    reject_request_info: 'This batch operation applies to resource requests created for both users and unnamed resources.',
    Reject_Success_Message: '1#{0} allocation has been rejected#{0} allocations have been rejected',
    rejected_by: 'Rejected by',
    remaining_total_capacity: 'Remaining total capacity',
    remaining_user_capacity: 'Remaining user capacity',
    replace_unnamed_with_real_to_approve_allocation: 'Replace an unnamed resource with a real user to approve the allocation.',
    replace_with_a_user: 'Replace with a user',
    request_for_approval_label: 'Request for approval',
    request_from: 'Request from',
    resource_allocated_plural: '1#{0} resource was allocated#{0} resources were allocated',
    resource_approval_selector_disabled_label: 'Resource approvals available only for soft allocations',
    resource_types_disabled_user_label: 'Disabled users',
    scheduled_hours_label: 'Scheduled hours',
    see_detailed_allocations: 'See detailed allocations',
    select_user: 'Select user',
    SkillsColumn: 'Skills',
    soft_allocation_with_a_resource_request_options: 'Soft allocation with a resource request',
    SoftAllocation: 'Soft allocation',
    streamline_your_project: 'Streamline your project management by effectively allocating and tracking resources.',
    total_allocated_hours_calculation_description: 'Number of hours resource is planned to work on the project, calculated based on the working hours, weekends, public holidays defined in the company settings.',
    total_allocated_hours_calculation_formula: 'Total allocated hours = (allocation duration - public holidays) * company working hours * allocation percentage',
    total_allocated_hours_label: 'Total allocated hours',
    total_demand: 'Total demand',
    uncheck_all: 'Uncheck all',
    underloaded_label: 'Underloaded',
    unnamed_resource_allocation: 'Unnamed resource allocation',
    unnamed_resource_demand: 'Unnamed resource demand',
    unnamed_workload_label: 'Unnamed resource workload',
    user_demand: 'User demand',
    users_select_empty_text: 'You have no users available.',
    vacation_label: 'Vacation',
    working_hours_message: 'Working hours – {0} per day.',
};
